import {
  APP_ZONES,
  CardTransactionType,
  CurrencyExchangeTransactionType,
  PermissionConfig,
  TransactionContextOptions,
  WidgetNames,
  WorkflowConfig,
  WorkflowPageConfig,
  WorkflowWidgetConfigurationAttributes,
} from '@finxone-platform/shared/sys-config-types';

export const getV1_0_168ToV1_0_169 = (workflowConfig: WorkflowConfig) => {
  const oneToOneKeys = Object.keys(workflowConfig);
  const mappingObject = {};
  // Assign mappings to not modify this version upgrade
  oneToOneKeys.forEach((key) => {
    Object.assign(mappingObject, {
      [key]: key,
    });
  });
  return {
    ...mappingObject,
    // add new version number
    version: {
      key: 'version',
      transform: () => {
        return 'v1.0.169';
      },
    },
    permissionSections: {
      key: 'permissionSections',
      transform: function (permissionSection: PermissionConfig): PermissionConfig {
        const { roles, subscriptions } = permissionSection;
        //look for all the transaction history and exchange history widgets in all the zones the widget can be placed, as per zone-list-array.ts
        roles.forEach((item) => {
          const zonesToUpdate = [
            item.zones[APP_ZONES.LANDING],
            item.zones[APP_ZONES.PROFILE],
            item.zones[APP_ZONES.ACCOUNTS_ZONE],
            item.zones[APP_ZONES.GENERAL],
          ];
          zonesToUpdate.forEach((zone) => {
            if (zone) {
              const mobilePages = zone?.canvases?.subscription?.['default']?.mobile?.pages as
                | WorkflowPageConfig[]
                | undefined;
              const desktopPages = zone?.canvases?.subscription?.['default']?.desktop?.pages as
                | WorkflowPageConfig[]
                | undefined;
              const tabletPages = zone?.canvases?.subscription?.['default']?.tablet?.pages as
                | WorkflowPageConfig[]
                | undefined;
              if (mobilePages?.length) {
                findPageAndUpdateWidget(mobilePages);
              }
              if (desktopPages?.length) {
                findPageAndUpdateWidget(desktopPages);
              }
              if (tabletPages?.length) {
                findPageAndUpdateWidget(tabletPages);
              }
            }
          });
        });
        return <PermissionConfig>{
          zones: permissionSection.zones,
          subscriptions,
          roles,
          projectForms: permissionSection.projectForms,
        };
      },
    },
  };
};

const findPageAndUpdateWidget = (pagesArray: WorkflowPageConfig[]): WorkflowPageConfig[] => {
  /**
   * Finds a page that has a transaction history widget and update its transactionContext property.
   *
   */
  for (const page of pagesArray) {
    if (!page) continue;
    page.widgets = page.widgets.map((widget) => {
      if (widget.name === WidgetNames.RECENT_TRANSACTION_LIST_WIDGET) {
        widget.widgetConfiguration.attributes['transactionContext'] = setTransactionContext(
          widget.widgetConfiguration.attributes,
        );
      }
      return widget;
    });
    break;
  }
  return pagesArray;
};

//basically the same function that was previously assiginig the context based on the defaultTransactionType in recent-transaction-history-configuration.component.ts

const setTransactionContext = (
  widgetAttributes: WorkflowWidgetConfigurationAttributes,
): TransactionContextOptions => {
  const defaultTransactionType = widgetAttributes['defaultTransactionType'];
  const currencyExchangeTypes = [
    CurrencyExchangeTransactionType.CURRENCYALL,
    CurrencyExchangeTransactionType.CURRENCYINCOMING,
    CurrencyExchangeTransactionType.CURRENCYOUTGOING,
  ];
  let transactionContext = TransactionContextOptions.TRANSACTION;
  const cardTransaction = [CardTransactionType.CARD_TRANSACTION_ALL];
  if (defaultTransactionType) {
    if (currencyExchangeTypes.includes(defaultTransactionType as CurrencyExchangeTransactionType)) {
      transactionContext = TransactionContextOptions.EXCHANGES;
    } else if (cardTransaction.includes(defaultTransactionType as CardTransactionType)) {
      transactionContext = TransactionContextOptions.CARD_TRANSACTION;
    }
  }
  return transactionContext;
};
